// Extract image URLs from textBlocks array
import { TextBlock } from '../interfaces/textEditor.interface';

export const extractImageUrlsFromTextBlocks = (
  textBlocks: TextBlock[],
): string[] => {
  const imageUrls: string[] = [];

  textBlocks.forEach((block, index) => {
    try {
      // Check if the block is an image type
      if (block.type === 'Image') {
        // Navigate to the nested URL: data.file.url
        const url = block.data?.file?.url;

        if (url && typeof url === 'string') {
          imageUrls.push(url);
        } else {
          console.warn(`Image block ${index} missing or invalid URL:`, block);
        }
      }
    } catch (error) {
      console.error(`Error processing block ${index}:`, error);
    }
  });

  return imageUrls;
};
